(ns ui.editor2.audio-player
  (:require [ui.editor2.common :as common]
            ["howler" :refer [Howl]]
            ))

(defn extract-file-extension
  "Extracts the file extension from a given filename string.
   Returns the extension without the leading dot, or nil if no extension is detected."
  [filename]
  (when-let [[_ ext] (re-find #"\.([^./\\]+)$" filename)]
    ext))

(def content-type->format
  {"audio/mpeg" "mp3"
   "audio/mp4" "m4a"
   "audio/aac" "aac"
   "audio/ogg" "ogg"
   "audio/wav" "wav"
   "audio/webm" "webm"
   "audio/flac" "flac"})

(defn audio-format
  "Howler needs the audio format, since it cannot be derived from
   extension-less URLs like /blob/{uuid}. Falls back from the file
   extension of the asset name to the content type (e.g. the music
   sticker audio, whose asset name is the song title without an
   extension)."
  [asset]
  (or (extract-file-extension (:asset/name asset))
      (get content-type->format
           (:asset/content-type asset))))

(defn create-audio-player!
  [store audio-clip]
  (let [path [:editor2
              :audio-players
              (:clip/uuid audio-clip)]]
    (when-not (get-in @store
                      path)
      (swap! store
             assoc-in
             path
             (Howl.
               (let [asset (:clip/asset audio-clip)
                     format (audio-format asset)
                     params (cond-> {:src [(:asset/uri asset)]}
                                    format
                                    (assoc :format [format]))]
                 (clj->js params)))))))

(defn remove-audio-player!
  "Unloads and forgets the Howl of the given clip, so that the next
   `ensure-audio-players!` creates a fresh one (e.g. after the clip's
   asset got a new audio URI)."
  [store clip-uuid]
  (when-let [howl (get-in @store
                          [:editor2
                           :audio-players
                           clip-uuid])]
    (.unload howl))
  (swap! store
         update-in
         [:editor2 :audio-players]
         dissoc
         clip-uuid))

(defn ensure-audio-players!
  [store]
  (doseq [audio-clip (common/get-all-audio-clips @store)]
    (create-audio-player! store
                          audio-clip)))

(comment
  (require 'ui.store)

  (do
    (def example-audio-player
      (Howl. #js {:src #js ["https://cdn.pixabay.com/audio/2025/03/04/audio_24c6849ea8.mp3"]}))
    ;; To prevent 'INTERNAL REPL ERROR: Got an unexpected reply from relay,
    ;; check InspectTimeout while waiting for result.' `nil` is returned.
    nil)

  (.play example-audio-player)

  (def audio-player
    (second
      (first
        (get-in @ui.store/store
                [:editor2
                 :audio-players]))))

  (.play audio-player)
  )
